import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Blueshift } from '../multi-select.component';
import { Platform, PopoverController } from '@ionic/angular';
import { PopoverComponent } from './pop-over/pop-over.component';
@Component({
  selector: 'app-blueshift-view',
  templateUrl: './blueshift-view.component.html',
  styleUrls: ['./blueshift-view.component.scss'],
})
export class BlueshiftViewComponent {

  @Input() blueshift: Blueshift;
  @Output() blueshiftClickEvent = new EventEmitter<object>();

  constructor(
    private popoverController: PopoverController,
    private platform: Platform
  ) { }

  async click(e: Event) {
    // do nothing if button cannot be clicked
    if (this.isUnselectable()) {
      await this.presentPopover(this.getHoverOverMessaging(), e);
    } else {
      this.blueshift.isSelected = !this.blueshift.isSelected;
      // emit Blueshift object for parent components to consume
      this.blueshiftClickEvent.emit({
        blueshift: this.blueshift
      });
    }
  }

  isUnselectable(): boolean {
    return this.blueshift.doesConflictWithExistingJob || this.blueshift.doesConflictWithOtherShift;
  }

  getCSSClass(): string {
    let className: string;
    if (this.blueshift.doesConflictWithExistingJob) {
      className = 'overlap-existing';
    } else if (this.blueshift.doesConflictWithOtherShift) {
      className = 'overlap';
    } else if (this.blueshift.isSelected) {
      className = 'selected';
    } else {
      className = 'unselected';
    }

    return className;
  }

  getHoverOverMessaging(): string {
    let message: string = '';
    if (this.blueshift.doesConflictWithExistingJob) {
      message = 'You have a conflict.';
    } else if (this.blueshift.doesConflictWithOtherShift) {
      message = 'This shift conflicts with one of your selections.';
    }
    return message;
  }
  
  getDirectInviteIcon(): string {
    return this.blueshift.isSelected ? '/assets/icons/envelope-airplane-white.svg' : '/assets/icons/envelope-airplane-blue.svg';
  }

  shouldDisableButton(): boolean {
    return this.isUnselectable() && this.platform.is('desktop');
  }

  async presentPopover(message: string, e: Event) {
    const popover = await this.popoverController.create({
      component: PopoverComponent,
      event: e,
      componentProps: {
        message: message
      },
      cssClass: 'small-popover',
    });
    await popover.present();
  }
}
